<script setup>
import Header from '@/components/Header.vue';
import { useConfigStore } from '@/stores/useConfigStore.js';
import api from '@/libs/api.js';
import { ref, watch, onMounted } from "vue"
const useConfig = useConfigStore();
const hotlines = ref({})
// watch(
//     () => useConfig,
//     (newContract) => {
//         if (newContract?.contract?.id) {
          
//             getData();
//         }
//     },
//     { immediate: true } // Chạy ngay khi component được mount nếu `contract` đã có giá trị
// );
onMounted(() => {
     getData();
})
const getData = async () => {
    if (useConfig.contract?.id) { // Đảm bảo `contract` và `id` tồn tại
        await api.get("/hotline",{
            params:{
                project_id : useConfig.contract.project_id,
                owner_id :  useConfig.contract.owner_id
            }
        }).then((res) => {
            hotlines.value = res.data.data; // data trả về từ server
        })
    }
};

const callPhoneNumber = (phoneNumber) => {
  window.location.href = `tel:${phoneNumber}`;
};
</script>
<template>
    <div class="w-full h-full animation_page overflow-auto">
        <Header text="HOTLINE" :url="{ name: 'user' }"></Header>
        <div class="w-full h-auto pt-14 divide-y" v-if="hotlines.data && hotlines.data.length > 0">
            <div v-for="(item, index) in hotlines.data" :key="index" @click="callPhoneNumber(phone)" class="px-6 py-2 flex justify-center flex-col items-start">
                <p class="font-bold">{{ item.name }}</p>
                <p class="">{{ item.phone }}</p>
            </div>
        </div>
    </div>
</template>